import request from '../servises/microRequest'
let horizon_url = 'horizon/api/'

export function sentBash (data) {
  let params
  return request({
    url:   'api/bash/',
    method: 'POST',
    data: data,
  })
}

export function getStats (pr) {
  let params
  return request({
    url: horizon_url + 'stats',
    method: 'GET',
    suppressError: true
  })
}

export function getWorkload() {
  return request({
    url:  horizon_url +`workload`,
    method: 'GET',
    suppressError: true
  })
}

export function getMasters() {
  return request({
    url:  horizon_url +`masters`,
    method: 'GET',
    suppressError: true
  })
}

export function getFailedJobs(pr) {
  let params;
    if (pr) {
      params = `?${pr}`
    }
  return request({
    url:  horizon_url +(pr ?`jobs/failed${params}` :`jobs/failed`),
    method: 'GET',
    suppressError: true
  })
}

export function getRecentJobs(pr) {
  let params;
  if (pr) {
    params = `?${pr}`
  }
  return request({
    url:  horizon_url +(pr ?`jobs/recent${params}` :`jobs/recent`),
    method: 'GET',
    suppressError: true
  })
}
